import { render, staticRenderFns } from "./companyIntro.vue?vue&type=template&id=fb28a1ae&scoped=true&"
import script from "./companyIntro.vue?vue&type=script&lang=js&"
export * from "./companyIntro.vue?vue&type=script&lang=js&"
import style0 from "./companyIntro.vue?vue&type=style&index=0&id=fb28a1ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb28a1ae",
  null
  
)

export default component.exports